module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "TOC"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Epigraph#epigraphpage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062016706_Part_1#part01"
    }
  }, [_vm._v("Part One")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_1#chapter01"
    }
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_2#chapter02"
    }
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_3#chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_4#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Part_2#part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_5#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_6#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_7#chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Part_3#part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_8#chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_9#chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_12#chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Part_4#part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_13#chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_14#chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_15#chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_16#chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Part_5#part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_17#chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_18#chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_19#chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_20#chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Part_6#part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_21#chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_22"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_22#chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_23"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_23#chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_24"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_24#chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Part_7#part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_25"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_25#chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_26"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_26#chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_27"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_27#chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_28"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_28#chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Part_8#part08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Eight")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_29"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_29#chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_30"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_30#chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Part_9#part09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Nine")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_31"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_31#chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_32"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Chapter_32#chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "backmatterpage_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Backmatter#backmatterpage02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plus:")]), _vm._v(" Insights, Interviews, And More")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "acknowledgment_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Acknowledgment#acknowledgmentpage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "adcard_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_AlsoBy#adcardpage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books by Tim Farrington")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "copyright_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062016706_Copyright#copyrightpage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "aboutpublisher_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#aboutpublisherpage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c315ba4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062016706_Contents.vue
// module id = 69
// module chunks = 0